/* eslint-disable @typescript-eslint/ban-types, @typescript-eslint/no-empty-function */
import { isPlatformBrowser } from '@angular/common';
import { ClassProvider, FactoryProvider, InjectionToken, PLATFORM_ID } from '@angular/core';
import { Request } from 'express';

/**
 * Create a new injection token for injecting the window into a component.
 * @deprecated
 */
export const WINDOW = new InjectionToken<WindowUsedInterface>('WindowToken');

/**
 * @deprecated
 */
export interface WindowUsedInterface {
  location: {
    assign: Function;
  };
  requestAnimationFrame: Function;
}

/**
 * Define abstract class for obtaining reference to the global window object.
 * @deprecated
 */
export abstract class WindowRef {
  get nativeWindow(): any {
    throw new Error('Not implemented.');
  }
}

/**
 * Define class that implements the abstract class and returns the native window object.
 * @deprecated
 */
export class BrowserWindowRef extends WindowRef {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor() {
    super();
  }

  get nativeWindow(): any {
    return window;
  }
}

/**
 * Create an factory function that returns the native window object.
 * @param browserWindowRef
 * @param platformId
 * @param request
 * @returns
 * @deprecated
 */
export function windowFactory(browserWindowRef: BrowserWindowRef, platformId: Object, request?: Request): any {
  if (isPlatformBrowser(platformId) && browserWindowRef && browserWindowRef.nativeWindow) {
    return browserWindowRef.nativeWindow;
  }

  const noop = () => {};

  return {
    location: {
      origin: request ? `${request.protocol}://${request.get('host')}` : '',
      pathname: request ? request.url : '',
      assign: noop,
    },
    performance: {
      now: noop,
    },
    setInterval: noop,
    clearInterval: noop,
    scrollTo: noop,
    requestAnimationFrame: noop,
    addEventListener: noop,
    removeEventListener: noop,
    devicePixelRatio: 1,
    navigator: { platform: '' },
    getComputedStyle: () => ({ getPropertyValue: () => '' }),
  };
}

/**
 * Create a injectable provider for the WindowRef token that uses the BrowserWindowRef class.
 * @deprecated
 */
const browserWindowProvider: ClassProvider = {
  provide: WindowRef,
  useClass: BrowserWindowRef,
};

/**
 * Create an injectable provider that uses the windowFactory function for returning the native window object.
 * @deprecated
 */
const windowProvider: FactoryProvider = {
  provide: WINDOW,
  useFactory: windowFactory,
  deps: [WindowRef, PLATFORM_ID],
};

/**
 * Create an array of providers.
 * @deprecated
 */
export const WINDOW_PROVIDERS = [browserWindowProvider, windowProvider];
